import { render, staticRenderFns } from "./ProductArticleDialog.vue?vue&type=template&id=e356edf2&scoped=true&"
import script from "./ProductArticleDialog.vue?vue&type=script&lang=ts&"
export * from "./ProductArticleDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProductArticleDialog.vue?vue&type=style&index=0&id=e356edf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e356edf2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})
